module.exports = __webpack_public_path__ + "images/2_NOON_Extension.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/feeds/2_NOON_Extension.png
// module id = 259
// module chunks = 0